import axios from 'axios'

function apiRoot() {
  return process.env.VUE_APP_API_ROOT
}

function friendlyError(data, fallback) {
  if (data && data.friendly && data.friendly.da) {
    return data.friendly.da
  }
  if (data && data.error && data.error.friendly && data.error.friendly.da) {
    return data.error.friendly.da
  }
  return fallback
}

export async function fetchConsumption({ start, vehicle, account }) {
  const params = { start }
  if (vehicle) params.vehicle = vehicle
  if (account) params.account = account

  const response = await axios.get(apiRoot() + '/consumption.php', { params })
  const data = response.data || {}
  if (data.authentificated === false) {
    const error = new Error(friendlyError(data, 'Du er ikke logget ind.'))
    error.code = 'not-authenticated'
    throw error
  }
  return {
    usages: data.usages || [],
    vehicles: data.vehicles || [],
    accounts: data.accounts || [],
    subscription: data.subscription || null
  }
}

export async function saveKmCorrection({ bookingId, field, km }) {
  try {
    const response = await axios.get(apiRoot() + '/booking-km-correction.php', {
      params: { bookingId, field, km }
    })
    const data = response.data || {}
    if (!data.success) {
      const error = new Error(friendlyError(data, 'Kunne ikke gemme km-rettelse.'))
      error.code = (data.error && data.error.alias) || 'save-failed'
      throw error
    }
    return data
  } catch (error) {
    if (error && error.code && error.code !== 'ERR_BAD_REQUEST' && error.response == null) {
      throw error
    }
    const data = error && error.response && error.response.data
    if (data) {
      const wrapped = new Error(friendlyError(data, 'Kunne ikke gemme km-rettelse.'))
      wrapped.code = (data.error && data.error.alias) || 'save-failed'
      throw wrapped
    }
    throw error
  }
}

export async function fetchInvoiceMailPreview() {
  const response = await axios.get(apiRoot() + '/invoice-mails.php', {
    params: { mode: 'preview' }
  })
  const data = response.data || {}
  if (data.success === false) {
    const error = new Error(friendlyError(data, 'Kunne ikke hente regnings-skabelon.'))
    error.code = (data.error && data.error.alias) || 'preview-failed'
    throw error
  }
  return {
    subject: data.subject || 'Regning, Byens Egen Bil – {husstand}',
    bodyTemplate: data.bodyTemplate || '',
    periods: data.periods || {},
    adminEmail: data.adminEmail || '',
    accounts: data.accounts || [],
    diagnostics: data.diagnostics || null
  }
}

export async function sendInvoiceMails() {
  const response = await axios.get(apiRoot() + '/invoice-mails.php', {
    params: { mode: 'send' }
  })
  const data = response.data || {}
  if (data.success === false && !(data.sent > 0)) {
    const error = new Error(
      (data.errors && data.errors[0]) || friendlyError(data, 'Kunne ikke sende regnings-mails.')
    )
    error.code = 'send-failed'
    throw error
  }
  return data
}
